import { apiGet } from '../../api'

export const all_payments = query => {
  return apiGet({
    endpoint: `payments/all_payments?${query}`
  })
}
